import React, { useContext, useEffect, useState } from 'react';
import { getImages } from '../Const'
import LeadItemAccordion from './LeadItemAccordion';
import Fancybox from '../Front/Fancybox';
import { LeadsContext } from '../Context/LeadsContext';

const LeadItem = ({ 
        leadData, 
        openPlainTextEmail, 
        handleAccordionClick, 
        openLead, 
        createNoteOpenModal, 
        textLeadModal, 
        handleMobArrow, 
        openDealStageModal,
        openMobArrow,
        mobLeadItem,
        cancelMobLeadItem,
        handleNotesMobileModal,
        openNotesMobModal,
        closeNotesMobModal,
        handleViewDocusign,
        leadType
    }) => {

    const { agentData, assignAgent, completeNextTask, updateLeadData, getImageType, addNote } = useContext(LeadsContext);

    const [assignee, setAssignee] = useState(leadData.agent_id || "unassigned");

    useEffect(() => {
        //console.log(assignee,leadData,leadData.agent_id,leadData.agent_id || "unassigned");
        setAssignee(leadData.agent_id || "unassigned");
    }, [leadData.agent_id]);

    

    const updateAssignee = (agent_id, email, vin) => {
        // console.log(agent_id, email, vin);
        setAssignee(agent_id);
        assignAgent(agent_id, email, vin);
    }

    const formattedNumber = leadData.Phone.replace(/[^\d\s]/g, '')
    let vehicleImages = leadData.Vehicle_Photos ? leadData.Vehicle_Photos.split(",") : [];
    let vehicleImage = vehicleImages.at(0);
    const imageUrl = vehicleImage;
    const [enterVinOpen, setEnterVinOpen] = useState(false);
    let timeoutId;
    const handleMouseEnter = () => {
        clearTimeout(timeoutId);
        setEnterVinOpen(true);
    };
    const handleMouseLeave = () => {
        timeoutId = setTimeout(() => {
            setEnterVinOpen(false);
        }, 500); // 2000 milliseconds = 2 seconds
    };
    const enterVinClose = () => {
        setEnterVinOpen(false)
    }
    // 
    const [appraisalOpenIndex, setAppraisalOpenIndex] = useState(null);
    const [pendingIndex, setPendingIndex] = useState(null);
    let timeoutId1 = null;
    const handleMouseEnter1 = (index) => {
        if (timeoutId1) {
            clearTimeout(timeoutId1);
            timeoutId1 = null;
        }
        setAppraisalOpenIndex(null);
        setTimeout(() => {
            setAppraisalOpenIndex(index);
        }, 0);
    };
    const handleMouseLeave1 = () => {
        timeoutId1 = setTimeout(() => {
            setAppraisalOpenIndex(null);
        }, 0); 
    };
    const handelMobAppraisal = (leadIndex) => {
        setAppraisalOpenIndex(leadIndex)
    }
    const appraisalClose = () => {
        setAppraisalOpenIndex(null);
    }
    // 
    const [notesOpen, setNotesOpen] = useState(null);
    let timeoutId2 = null;
    const handleMouseEnter2 = (index) => {
        if (timeoutId2) {
            clearTimeout(timeoutId2);
            timeoutId2 = null;
        }
        setNotesOpen(null);
        setTimeout(() => {
            setNotesOpen(index);
        }, 0);
    };
    const handleMouseLeave2 = () => {
        timeoutId2 = setTimeout(() => {
            setNotesOpen(null);
        }, 0); 
    };
    const notesClose = () => {
        setNotesOpen(false)
    }
    const [percent, setPercent] = useState(20)
    useEffect(() => {
        const chartElement = document.querySelector('.progress-pie-chart');
        const percentValue = parseFloat(percent);

        const deg = 360 * percent / 100;

        if (percentValue > 50) {
            chartElement.classList.add('gt-50');
        } else {
            chartElement.classList.remove('gt-50');
        }

        const ppcProgressFill = document.querySelector('.ppc-progress-fill');
        ppcProgressFill.style.transform = `rotate(${deg}deg)`;
    }, [percent]);

    // Timer Calculation Function
    // Convert current Time Zone Format
    const [currentUtcTime, setCurrentUtcTime] = useState('');
    // console.log("currentUtcTime", currentUtcTime)
    useEffect(() => {
        const getCurrentUtcTime = () => {
            const now = new Date();
            const utcString = now.toISOString(); // Get UTC time in ISO format
            setCurrentUtcTime(utcString);
        };

        getCurrentUtcTime();
    }, []);
    // Convert current Time Zone Format
    const originalTimestamp = currentUtcTime;
    const dateObj = new Date(originalTimestamp);
    const year = dateObj.getUTCFullYear();
    const month = String(dateObj.getUTCMonth() + 1).padStart(2, '0');
    const day = String(dateObj.getUTCDate()).padStart(2, '0');
    const hours = String(dateObj.getUTCHours()).padStart(2, '0');
    const minutes = String(dateObj.getUTCMinutes()).padStart(2, '0');
    const seconds = String(dateObj.getUTCSeconds()).padStart(2, '0');

    const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

    // Get Different Between both time
    const createdAtDate = new Date(leadData.created_at);
    const currentUtcTimeDate = new Date(leadData.stop_clock || formattedDate);
    const timeDifference = currentUtcTimeDate.getTime() - createdAtDate.getTime();
    const timeDifferenceInSeconds = Math.abs(timeDifference / 500);
    // let timeDifferenceInMinutes = timeDifferenceInSeconds / 60;

    const [finalTimeDifferent, setFinalTimeDifferent] = useState("");
    const [timeLabel, setTimeLabel] = useState("");
    const [stateCls, setStateCls] = useState("");
    useEffect(() => {
        let timeDifferenceInMinutes = timeDifferenceInSeconds / 60;

        if (timeDifferenceInMinutes > 59) {
            const timeDifferenceInHours = Math.floor(timeDifferenceInMinutes / 60);
            if (timeDifferenceInHours > 24) {
                setFinalTimeDifferent("24+");
            } else {
                setFinalTimeDifferent(timeDifferenceInHours);
            }
            setTimeLabel("hrs");
            setStateCls("red");
        } else {
            timeDifferenceInMinutes = Math.round(timeDifferenceInMinutes);
            // console.log("timeDifferenceInMinutes", timeDifferenceInMinutes)
            setFinalTimeDifferent(timeDifferenceInMinutes);
            if (timeDifferenceInMinutes <= 5) {
                setStateCls("green");
            } else if (timeDifferenceInMinutes >= 6 && timeDifferenceInMinutes <= 10) {
                setStateCls("yellow");
            } else {
                setStateCls("red");
            }
            setTimeLabel("min");
        }
    }, [timeDifferenceInSeconds]);

    useEffect(() => {
        if (document.getElementById(`${openLead}`)) {
            window.scrollTo(0,
                findPosition(document.getElementById(`${openLead}`)));
        }
    }, [openLead]);

    function findPosition(obj) {
        var currenttop = 0;
        if (obj.offsetParent) {
            do {
                currenttop += obj.offsetTop;
            } while ((obj = obj.offsetParent));
            return [currenttop];
        }
    }
    // characters
    const [isTruncated, setIsTruncated] = useState(true);

    const toggleTruncate = () => {
        setIsTruncated(!isTruncated);
    };

    const [emailSent, setEmailSent] = useState(leadData.email_sent);
    const [phoneCall, setPhoneCall] = useState(leadData.phone_call);
    const [appraisal, setAppraisal] = useState(leadData.appraisal);
    const [docusignSent, setDocusignSent] = useState(leadData.docusign);

    useEffect(() => {
        //console.log(assignee,leadData,leadData.agent_id,leadData.agent_id || "unassigned");
        setEmailSent(leadData.email_sent);
        setPhoneCall(leadData.phone_call);
        setAppraisal(leadData.appraisal)
    }, [leadData]);

    
    const completeTask = async (leadData, type) => {
        const task_id = await completeNextTask(leadData.Email, leadData.Vin_Number, type);

        // console.log("leaditem completeTask", leadData.Email, leadData.Vin_Number, leadData.tasks);
        
        if (type == 'email') setEmailSent(!emailSent);
        if (type == 'call') setPhoneCall(!phoneCall);
        if (task_id) {
            var newTaskData = [];

            leadData.tasks.map((v, i) => {
                if (v.id == task_id) v['completed'] = 1;
                newTaskData.push(v);
            });

            leadData.tasks = newTaskData;

        } else {

        }
        //refresh task data
    }

    const sendDocusign = (status) => {

        updateLeadData(leadData.Email, leadData.Vin_Number, 'docusign', status ? 1 : 0);

        setDocusignSent(status);

        //refresh task data
    }

    const addAppraisal = (e) => {
        e.preventDefault();

        const formData = Object.fromEntries(new FormData(e.target));

        setAppraisal(formData.appraisal);

        updateLeadData(formData.email, formData.vin, 'appraisal', formData.appraisal);

        const values = {'email':formData.email,'vin':formData.vin,'title':'Appraisal Added','subtitle':leadData.agent_name,'note':formData.appraisal};

        addNote(values);

        //refresh task data
    }

    const floatFormatter = (value, currency = false) => {
        var num = value ? value.toString().replace(/[^0-9\.]+/g, "") : 0;
        var thousands = num > 500;

        if (thousands) num = Math.round(num / 100) / 10;

        var sign = num >= 0 ? "" : "-";
        var str = num.toString().replace("$", ""), parts = false, output = [], i = 1, formatted = null;
        if (str.indexOf(".") > 0) {
            parts = str.split(".");
            str = parts[0];
        }
        str = str.split("").reverse();
        for (var j = 0, len = str.length; j < len; j++) {
            if (str[j] != ",") {
                output.push(str[j]);
                if (i % 3 == 0 && j < (len - 1)) {
                    output.push(",");
                }
                i++;
            }
        }
        formatted = output.reverse().join("");
        return ((currency ? "$" : "") + sign + formatted + ((parts) ? "." + parts[1].substr(0, 2) : "") + (thousands ? "k" : ""));
    }

    const dealStages = [
        'Waiting Response', 
        'Agent Responded', 
        'Appraisal Given', 
        'Appraisal Accepted', 
        'Passed to Finalizers'
    ];
    return (
        <>
            <tr id={leadData.lead_id}>
                <td className={`p-0 col-parent ${mobLeadItem === leadData.lead_id ? 'parent-mob-active':''}`}>
                    <div className='mob-lead-item d-lg-none mb-3'>
                        <table className='w-100'>
                            <tbody>
                                <tr>
                                    <td className='w-100'>
                                        <div className='d-flex align-items-center'>
                                            <div>
                                                {leadData.Vehicle_Photos ?
                                                    <div className='pd-img pd-gallery-img position-relative'>
                                                        <Fancybox
                                                            options={{
                                                                Carousel: {
                                                                    infinite: false,
                                                                },
                                                            }}
                                                        >
                                                            {vehicleImages && vehicleImages.map((imgItem, index) =>
                                                                <a key={index} data-fancybox="gallery" href={imgItem} target="_blank">
                                                                    <img src={imgItem} alt={leadData.Vehicle_Make} />
                                                                </a>
                                                            )}
                                                            {vehicleImages.length > 1 ? <div className='vi-count'>+{vehicleImages.length}</div> : ""}
                                                        </Fancybox>
                                                    </div> :

                                                    <div className='pd-no-img position-relative no-photo-pos' onClick={(e) => openPlainTextEmail(leadData,leadData.Vin_Number ? 'No Photos' : 'No Vin, No Photos')}>
                                                        <img src={getImages("thumb-no-photo.png")} alt='thumb' />
                                                        {/* <input type='file' /> */}
                                                    </div>
                                                }
                                            </div>
                                            <div className='ps-4'>
                                                    <div className='d-lg-none pd-sm-title mb-2' onClick={()=>handleMobArrow(leadData)}>{leadData.First_Name} {leadData.Last_Name}</div>
                                                    <div className='pd-sm-title' onClick={()=>handleMobArrow(leadData)}>{leadData.Vehicle_Year} {leadData.Vehicle_Make}</div>
                                                    {leadData.Vin_Number ?
                                                        <>
                                                            <div className='pd-xs-title my-2 text-uppercase' onClick={()=>handleMobArrow(leadData)}>{leadData.Vin_Number}</div> 
                                                        </>
                                                        : <>
                                                            <div className={`sm-box-relative d-inline-block mob-large-modal ${enterVinOpen ? "open" : ""}`}
                                                                onMouseEnter={handleMouseEnter}
                                                                onMouseLeave={handleMouseLeave}
                                                            >
                                                                <div className={`overlay-modal ${enterVinOpen ? "open" : ""}`} onClick={enterVinClose}></div>
                                                                <div className='sm-box-pos mob-large-modal-pos'>
                                                                    <div className='sm-box-header mb-3'>Enter VIN # <button className='sm-box-close' type='button' onClick={enterVinClose}><i className="fa-solid fa-xmark"></i></button></div>
                                                                    <div className='custom-form'>
                                                                        <div className='form-group mb-4'>
                                                                            <label className='cs-label text-dgray'>VIN</label>
                                                                            <input type='text' className='form-control' />
                                                                        </div>
                                                                        <div className='text-center px-3 pb-4'>
                                                                            <button className='blue-btn mnw-170 text-center text-uppercase'>Save</button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div>
                                                                    <button type='button' className='pd-sm-title text-blue text-uppercase need-vin-btn mt-2 pb-0' onClick={handleMouseEnter}>Need Vin</button>
                                                                </div>
                                                            </div>
                                                        </>
                                                    }
                                            </div>
                                            <div className='ms-auto'>
                                                <button className="mob-lead-btn"
                                                    type="button"
                                                    onClick={()=>{handleMobArrow(leadData.lead_id); handleAccordionClick(leadData.lead_id);}}
                                                >
                                                    <span className='btn-arrow' type='button'></span>
                                                </button>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="accordion-item">
                        <button className='mob-back-btn p-0 d-lg-none' type='button' onClick={cancelMobLeadItem}><span className='ps-0'><img src={getImages('left-arrow.svg')} /></span> Back</button>
                        <table className='w-100'>
                            <tbody>
                                {leadType == "CloseOut" ? 
                                <tr>
                                    <td className='align-middle mob-d-none ps-4' style={{ width: "5%" }}>
                                        <h2 className="accordion-header p-0">
                                            <button className={`accordion-button p-0 ${openLead === leadData.lead_id ? "" : "collapsed"}`}
                                                type="button"
                                                onClick={() => handleAccordionClick(leadData.lead_id)}
                                            >
                                                <span className='btn-arrow accordionTitle' type='button'></span>
                                            </button>
                                        </h2>
                                    </td>
                                    <td style={{ width: "25%" }}>
                                        <div className='d-flex align-items-center'>
                                            {leadData.Vehicle_Photos ?
                                                <div className='pd-img pd-gallery-img position-relative'>
                                                    <Fancybox
                                                        options={{
                                                            Carousel: {
                                                                infinite: false,
                                                            },
                                                        }}
                                                    >
                                                        {vehicleImages && vehicleImages.map((imgItem, index) =>
                                                            <a key={index} data-fancybox="gallery" href={imgItem} target="_blank">
                                                                <img src={imgItem} alt={leadData.Vehicle_Make} />
                                                            </a>
                                                        )}
                                                        {vehicleImages.length > 1 ? <div className='vi-count'>+{vehicleImages.length}</div> : ""}
                                                    </Fancybox>
                                                </div> :

                                                <div className='pd-no-img position-relative no-photo-pos' onClick={(e) => openPlainTextEmail(leadData,leadData.Vin_Number ? 'No Photos' : 'No Vin, No Photos')}>
                                                    <img src={getImages("thumb-no-photo.png")} alt='thumb' />
                                                    {/* <input type='file' /> */}
                                                </div>
                                            }
                                            <div className='pd-content ps-4 d-none d-lg-block'>
                                                <div className='pd-sm-title'>{leadData.First_Name} {leadData.Last_Name}</div>
                                                <div className='pd-xs-title my-2'><a className='pd-xs-title' href={`tel:${formattedNumber}`}>{leadData.Phone}</a></div>
                                                <div className='pd-email' onClick={(e) => openPlainTextEmail(leadData)}>{leadData.Email}</div>
                                            </div>
                                        </div>
                                    </td>
                                    <td style={{ width: "15%" }}>
                                        <div>
                                            <div className='pd-sm-title mob-font-18'>{leadData.Vehicle_Year} {leadData.Vehicle_Make}</div>
                                            {leadData.Vin_Number ?
                                                <>
                                                    <div className='pd-xs-title my-2 text-uppercase mob-font-18 mob-text-blue'><span className='d-none d-lg-inline-block'>VIN#</span> {leadData.Vin_Number}</div> 
                                                </>
                                                : <>
                                                    <div className={`sm-box-relative d-inline-block mob-large-modal ${enterVinOpen ? "open" : ""}`}
                                                        onMouseEnter={handleMouseEnter}
                                                        onMouseLeave={handleMouseLeave}
                                                    >
                                                        <div className={`overlay-modal ${enterVinOpen ? "open" : ""}`} onClick={enterVinClose}></div>
                                                        <div className='sm-box-pos mob-large-modal-pos'>
                                                            <div className='sm-box-header mb-3'>Enter VIN # <button className='sm-box-close' type='button' onClick={enterVinClose}><i className="fa-solid fa-xmark"></i></button></div>
                                                            <div className='custom-form'>
                                                                <div className='form-group mb-4'>
                                                                    <label className='cs-label text-dgray'>VIN</label>
                                                                    <input type='text' className='form-control' />
                                                                </div>
                                                                <div className='text-center px-3 pb-4'>
                                                                    <button className='blue-btn mnw-170 text-center text-uppercase'>Save</button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <button type='button' className='pd-sm-title text-blue text-uppercase need-vin-btn my-2 mob-font-18'>Need Vin</button>
                                                    </div>
                                                </>
                                            }
                                            <div className='pd-xs-title d-flex align-items-center justify-content-between mob-table-str'>
                                                <div className='w-60'><span>Miles:</span> <span>{leadData.Vehicle_Mileage}</span></div>
                                                <div className='w-40 text-capitalize'><span>Color:</span> <span>{leadData.Vehicle_Exterior}</span></div>
                                                <div className='d-lg-none'>
                                                    <span>Appraisal:</span> 
                                                    <span>
                                                        {appraisal ?
                                                            <div className='text-center pd-sm-title text-blue'>{floatFormatter(appraisal, true)}</div> :
                                                            <div className='text-center cs-close'>
                                                                <button type='button' onClick={()=>handelMobAppraisal(leadData.lead_id)}
                                                                    className='btn-transparent'><span className='close-icon'></span></button>
                                                            </div>
                                                        }
                                                    </span>
                                                </div>
                                            </div>
                                            <div className={`d-lg-none sm-box-relative d-inline-block  text-start appraisal-modal ${appraisalOpenIndex === leadData.lead_id ? "open" : ""}`}
                                            >
                                                {/* <div className={`overlay-modal ${appraisalOpen === index ? "open" : ""}`} 
                                                    ></div> */}
                                                <div className='sm-box-pos'>
                                                    <div className='sm-box-header mb-3'>Update Appraisal <button className='sm-box-close' type='button' onClick={appraisalClose}><i className="fa-solid fa-xmark"></i></button></div>
                                                    <form className='custom-form' onSubmit={(e) => addAppraisal(e)}>
                                                        <input type="hidden" name="email" value={leadData.Email} />
                                                        <input type="hidden" name="vin" value={leadData.Vin_Number} />
                                                        <div className='form-group mb-4'>
                                                            <label className='cs-label text-dgray'>Fixed Price</label>
                                                            <input type='text' className='form-control' name="appraisal" />
                                                        </div>
                                                        {/* <div className='form-group mb-4'>
                                                                <label className='cs-label text-dgray'>Price Range</label>
                                                                <div className='row'>
                                                                    <div className='col-6'>
                                                                        <input type='text' className='form-control' />
                                                                    </div>
                                                                    <div className='col-6'>
                                                                        <input type='text' className='form-control' />
                                                                    </div>
                                                                </div>
                                                            </div> */}
                                                        <div className='text-center px-3 pb-4'>
                                                            <button className='blue-btn mnw-170 text-center text-uppercase' type="submit">Save</button>
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                    <td style={{ width: "10%" }} className='text-center cs-close pt-3 mob-w-25'>
                                        <div className='mb-2 mob-tb-title d-lg-none'>Price</div>
                                        <div className='xs-title font-15 pt-md-3'>{appraisal ? floatFormatter(appraisal, true) : ""}</div>
                                    </td>
                                    <td style={{ width: "10%" }} className='text-center cs-close pt-3 mob-w-25'>
                                        <div className='mb-2 mob-tb-title d-lg-none'>DocuSign <br />Sent</div>
                                        {docusignSent ?
                                            <button type='button' className='btn-transparent mt-md-2'>
                                                <span className='green-check-icon' onClick={(e) => sendDocusign(false)}></span>
                                            </button> :
                                            <button type='button' className='btn-transparent mt-md-2' onClick={(e) => sendDocusign(true)}>
                                                <span className='close-icon'></span>
                                            </button>
                                        }
                                    </td>
                                    <td style={{ width: "10%" }} className='text-center pt-4 mob-w-25'>
                                        <div className='mb-2 mob-tb-title d-lg-none'>Notes</div>
                                        {/* {Notes && */}
                                        <div className={`sm-box-relative d-inline-block  text-start notes-modal ${notesOpen === leadData.lead_id ? "open" : ""} ${openNotesMobModal ? 'mob-notes-active' : ''}`}
                                            onMouseEnter={()=>handleMouseEnter2(leadData.lead_id)}
                                            onMouseLeave={handleMouseLeave2}
                                        >
                                            {/* <div className={`overlay-modal ${notesOpen === index ? "open" : ""}`} onClick={notesClose}></div> */}
                                            <div className='sm-box-pos'>
                                                <div className='sm-box-header mb-3'>Notes <button className='sm-box-close' type='button' onClick={()=>{notesClose(); closeNotesMobModal();}}><i className="fa-solid fa-xmark"></i></button></div>
                                                <div className='notes-scroll email-history-box notes-lits-box'>
                                                    {leadData.notes && leadData.notes.map((v, i) => {
                                                        const createdAtDate = new Date(v.created_at + " UTC");
                                                        return (
                                                            <div className='d-flex align-items-start mb-3' key={i}>
                                                                <div className='mnw-icon'>
                                                                    <img src={getImages(getImageType(v.title))} alt='envlope' />
                                                                </div>
                                                                <div className='ps-2'>
                                                                    <div className='pd-sm-title text-blue text-uppercase'>{v.title}</div>
                                                                    <div className='pd-xs-title mt-2 text-break-wrod'>{v.note}</div>
                                                                </div>
                                                                <div className='ms-auto'>
                                                                    <div className='d-flex'>
                                                                        <div className='pd-xs-title'>{createdAtDate.toLocaleString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true })}</div>
                                                                        <div className='pd-xs-title ms-4'>{createdAtDate.toLocaleString('en-US', { year: "2-digit", month: "2-digit", day: "numeric" })}</div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )
                                                    })}
                                                </div>
                                                <div className="text-start px-0">
                                                    <button className="blue-btn mnw-170 text-center" onClick={() => {createNoteOpenModal(leadData)}}>Create Note</button>
                                                </div>
                                            </div>
                                            <div className='d-md-block d-none'>
                                                <button className='file-icon' type='button'></button>
                                            </div>
                                        </div>
                                        
                                        <div className='d-lg-none'>
                                            <button className='file-icon' type='button' onClick={handleNotesMobileModal}></button>
                                        </div>
                                        {/* } */}
                                    </td>
                                    <td style={{ width: "10%" }} className='text-center pt-3 mob-w-25'>
                                        <div className='mb-2 mob-tb-title d-lg-none'>Days</div>
                                        <div className='xs-title font-15 pt-md-3'>4</div>
                                    </td>
                                    <td style={{ width: "15%" }} className='text-center pt-3'>
                                        <div className='mb-2 mob-tb-title d-lg-none text-start'>Assigned to</div>
                                        <select className='form-control sm-form-control w-100' value={assignee} onChange={(e) => updateAssignee(e.target.value, leadData.Email, leadData.Vin_Number)}>
                                            <option value={leadData.agent_id || "unassigned"}>{leadData.agent_name || "unassigned"}</option>
                                            {agentData.map((agent, i) => {
                                                return (<option value={agent.id} key={i}>{agent.full_name}</option>)
                                            })}
                                        </select>
                                    </td>
                                </tr>
                                :
                                <tr>
                                    <td className='align-middle mob-d-none ps-4' style={{ width: "5%" }}>
                                        <h2 className="accordion-header p-0">
                                            <button className={`accordion-button p-0 ${openLead === leadData.lead_id ? "" : "collapsed"}`}
                                                type="button"
                                                onClick={() => handleAccordionClick(leadData.lead_id)}
                                            >
                                                <span className='btn-arrow accordionTitle' type='button'></span>
                                            </button>
                                        </h2>
                                    </td>
                                    <td style={{ width: "25%" }}>
                                        <div className='d-flex align-items-center'>
                                            {leadData.Vehicle_Photos ?
                                                <div className='pd-img pd-gallery-img position-relative'>
                                                    <Fancybox
                                                        options={{
                                                            Carousel: {
                                                                infinite: false,
                                                            },
                                                        }}
                                                    >
                                                        {vehicleImages && vehicleImages.map((imgItem, index) =>
                                                            <a key={index} data-fancybox="gallery" href={imgItem} target="_blank">
                                                                <img src={imgItem} alt={leadData.Vehicle_Make} />
                                                            </a>
                                                        )}
                                                        {vehicleImages.length > 1 ? <div className='vi-count'>+{vehicleImages.length}</div> : ""}
                                                    </Fancybox>
                                                </div> :

                                                <div className='pd-no-img position-relative no-photo-pos' onClick={(e) => openPlainTextEmail(leadData,leadData.Vin_Number ? 'No Photos' : 'No Vin, No Photos')}>
                                                    <img src={getImages("thumb-no-photo.png")} alt='thumb' />
                                                    {/* <input type='file' /> */}
                                                </div>
                                            }
                                            <div className='pd-content ps-4 d-none d-lg-block'>
                                                <div className='pd-sm-title'>{leadData.First_Name} {leadData.Last_Name}</div>
                                                <div className='pd-xs-title my-2'><a className='pd-xs-title' href={`tel:${formattedNumber}`}>{leadData.Phone}</a></div>
                                                <div className='pd-email' onClick={(e) => openPlainTextEmail(leadData)}>{leadData.Email}</div>
                                            </div>
                                        </div>
                                    </td>
                                    <td style={{ width: "15%" }}>
                                        <div>
                                            <div className='pd-sm-title mob-font-18'>{leadData.Vehicle_Year} {leadData.Vehicle_Make}</div>
                                            {leadData.Vin_Number ?
                                                <>
                                                    <div className='pd-xs-title my-2 text-uppercase mob-font-18 mob-text-blue'><span className='d-none d-lg-inline-block'>VIN#</span> {leadData.Vin_Number}</div> 
                                                </>
                                                : <>
                                                    <div className={`sm-box-relative d-inline-block mob-large-modal ${enterVinOpen ? "open" : ""}`}
                                                        onMouseEnter={handleMouseEnter}
                                                        onMouseLeave={handleMouseLeave}
                                                    >
                                                        <div className={`overlay-modal ${enterVinOpen ? "open" : ""}`} onClick={enterVinClose}></div>
                                                        <div className='sm-box-pos mob-large-modal-pos'>
                                                            <div className='sm-box-header mb-3'>Enter VIN # <button className='sm-box-close' type='button' onClick={enterVinClose}><i className="fa-solid fa-xmark"></i></button></div>
                                                            <div className='custom-form'>
                                                                <div className='form-group mb-4'>
                                                                    <label className='cs-label text-dgray'>VIN</label>
                                                                    <input type='text' className='form-control' />
                                                                </div>
                                                                <div className='text-center px-3 pb-4'>
                                                                    <button className='blue-btn mnw-170 text-center text-uppercase'>Save</button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <button type='button' className='pd-sm-title text-blue text-uppercase need-vin-btn my-2 mob-font-18'>Need Vin</button>
                                                    </div>
                                                </>
                                            }
                                            <div className='pd-xs-title d-flex align-items-center justify-content-between mob-table-str'>
                                                <div className='w-60'><span>Miles:</span> <span>{leadData.Vehicle_Mileage}</span></div>
                                                <div className='w-40 text-capitalize'><span>Color:</span> <span>{leadData.Vehicle_Exterior}</span></div>
                                                <div className='d-lg-none'>
                                                    <span>Appraisal:</span> 
                                                    <span>
                                                        {appraisal ?
                                                            <div className='text-center pd-sm-title text-blue'>{floatFormatter(appraisal, true)}</div> :
                                                            <div className='text-center cs-close'>
                                                                <button type='button' onClick={()=>handelMobAppraisal(leadData.lead_id)}
                                                                    className='btn-transparent'><span className='close-icon'></span></button>
                                                            </div>
                                                        }
                                                    </span>
                                                </div>
                                            </div>
                                            <div className={`d-lg-none sm-box-relative d-inline-block  text-start appraisal-modal ${appraisalOpenIndex === leadData.lead_id ? "open" : ""}`}
                                            >
                                                {/* <div className={`overlay-modal ${appraisalOpen === index ? "open" : ""}`} 
                                                    ></div> */}
                                                <div className='sm-box-pos'>
                                                    <div className='sm-box-header mb-3'>Update Appraisal <button className='sm-box-close' type='button' onClick={appraisalClose}><i className="fa-solid fa-xmark"></i></button></div>
                                                    <form className='custom-form' onSubmit={(e) => addAppraisal(e)}>
                                                        <input type="hidden" name="email" value={leadData.Email} />
                                                        <input type="hidden" name="vin" value={leadData.Vin_Number} />
                                                        <div className='form-group mb-4'>
                                                            <label className='cs-label text-dgray'>Fixed Price</label>
                                                            <input type='text' className='form-control' name="appraisal" />
                                                        </div>
                                                        {/* <div className='form-group mb-4'>
                                                                <label className='cs-label text-dgray'>Price Range</label>
                                                                <div className='row'>
                                                                    <div className='col-6'>
                                                                        <input type='text' className='form-control' />
                                                                    </div>
                                                                    <div className='col-6'>
                                                                        <input type='text' className='form-control' />
                                                                    </div>
                                                                </div>
                                                            </div> */}
                                                        <div className='text-center px-3 pb-4'>
                                                            <button className='blue-btn mnw-170 text-center text-uppercase' type="submit">Save</button>
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                    <td style={{ width: "7%" }} className='text-center'>
                                        <div className='pd-personal-title mb-2 d-lg-none text-white text-start'>Customer Info</div>
                                        <div className='d-flex d-lg-block'>
                                            <div className='pd-content text-start d-lg-none'>
                                                <div className='pd-sm-title'>{leadData.First_Name} {leadData.Last_Name}</div>
                                                <div className='pd-xs-title my-2'><a className='pd-xs-title' href={`tel:${formattedNumber}`}>{leadData.Phone}</a></div>
                                                <div className='pd-email' onClick={(e) => openPlainTextEmail(leadData)}>{leadData.Email}</div>
                                            </div>
                                            <div onClick={() => {openDealStageModal(leadData)}} className='cursor-pointer'>
                                                <div className={`progress-pie-chart ${leadData.deal_stage + 1 > 3 ? 'gt-50': ''}`} data-percent={(leadData.deal_stage + 1) * 20}>
                                                    <span className="label">{leadData.deal_stage + 1}</span>
                                                    <div className="ppc-progress">
                                                        <div className="ppc-progress-fill" style={{ transform: `rotate(${(leadData.deal_stage + 1) * 72}deg)` }}></div>
                                                    </div>
                                                    <div className="ppc-percents">
                                                        <div className="pcc-percents-wrapper"></div>
                                                    </div>
                                                </div>
                                                <div className='xsm-title mt-2'>{dealStages[leadData.deal_stage]}</div>
                                            </div>
                                        </div>
                                    </td>
                                    <td style={{ width: "7%" }} className='pt-3 text-center mob-d-none'>
                                        <div className={`sm-box-relative d-inline-block  text-start appraisal-modal ${appraisalOpenIndex === leadData.lead_id ? "open" : ""}`}
                                            onMouseEnter={()=>handleMouseEnter1(leadData.lead_id)}
                                            onMouseLeave={handleMouseLeave1}
                                        >
                                            {/* <div className={`overlay-modal ${appraisalOpen === index ? "open" : ""}`} 
                                                ></div> */}
                                            <div className='sm-box-pos'>
                                                <div className='sm-box-header mb-3'>Update Appraisal <button className='sm-box-close' type='button' onClick={appraisalClose}><i className="fa-solid fa-xmark"></i></button></div>
                                                <form className='custom-form' onSubmit={(e) => addAppraisal(e)}>
                                                    <input type="hidden" name="email" value={leadData.Email} />
                                                    <input type="hidden" name="vin" value={leadData.Vin_Number} />
                                                    <div className='form-group mb-4'>
                                                        <label className='cs-label text-dgray'>Fixed Price</label>
                                                        <input type='text' className='form-control' name="appraisal" />
                                                    </div>
                                                    {/* <div className='form-group mb-4'>
                                                            <label className='cs-label text-dgray'>Price Range</label>
                                                            <div className='row'>
                                                                <div className='col-6'>
                                                                    <input type='text' className='form-control' />
                                                                </div>
                                                                <div className='col-6'>
                                                                    <input type='text' className='form-control' />
                                                                </div>
                                                            </div>
                                                        </div> */}
                                                    <div className='text-center px-3 pb-4'>
                                                        <button className='blue-btn mnw-170 text-center text-uppercase' type="submit">Save</button>
                                                    </div>
                                                </form>
                                            </div>
                                            {appraisal ?
                                                <div className='text-center pd-sm-title text-blue pt-4'>{floatFormatter(appraisal, true)}</div> :
                                                <div className='text-center cs-close'>
                                                    <button type='button'
                                                        className='btn-transparent'><span className='close-icon'></span></button>
                                                </div>
                                            }
                                        </div>
                                    </td>
                                    <td style={{ width: "7%" }} className='text-center cs-close pt-3 mob-w-25'>
                                        <div className='mb-2 mob-tb-title d-lg-none'>Email <br />Sent</div>
                                        {emailSent ?
                                            <button type='button' className='btn-transparent'>
                                                <span className='green-check-icon'  onClick={(e) => completeTask(leadData, 'email')}></span>
                                            </button> :
                                            <button type='button' className='btn-transparent' onClick={(e) => completeTask(leadData, 'email')}>
                                                <span className='close-icon'></span>
                                            </button>
                                        }
                                    </td>
                                    <td style={{ width: "7%" }} className='text-center cs-close pt-3 mob-w-25'>
                                        <div className='mb-2 mob-tb-title d-lg-none'>Phone <br />Sent</div>
                                        {phoneCall ?
                                            <button type='button' className='btn-transparent'>
                                                <span className='green-check-icon' onClick={(e) => completeTask(leadData, 'call')}></span>
                                            </button> :
                                            <button type='button' className='btn-transparent' onClick={(e) => completeTask(leadData, 'call')}>
                                                <span className='close-icon'></span>
                                            </button>
                                        }
                                    </td>
                                    <td style={{ width: "6%" }} className='text-center pt-4 mob-w-25'>
                                        <div className='mb-2 mob-tb-title d-lg-none'>Notes</div>
                                        {/* {Notes && */}
                                        <div className={`sm-box-relative d-inline-block  text-start notes-modal ${notesOpen === leadData.lead_id ? "open" : ""} ${openNotesMobModal ? 'mob-notes-active' : ''}`}
                                            onMouseEnter={()=>handleMouseEnter2(leadData.lead_id)}
                                            onMouseLeave={handleMouseLeave2}
                                        >
                                            {/* <div className={`overlay-modal ${notesOpen === index ? "open" : ""}`} onClick={notesClose}></div> */}
                                            <div className='sm-box-pos'>
                                                <div className='sm-box-header mb-3'>Notes <button className='sm-box-close' type='button' onClick={()=>{notesClose(); closeNotesMobModal();}}><i className="fa-solid fa-xmark"></i></button></div>
                                                <div className='notes-scroll email-history-box notes-lits-box'>
                                                    {leadData.notes && leadData.notes.map((v, i) => {
                                                        const createdAtDate = new Date(v.created_at + " UTC");
                                                        return (
                                                            <div className='d-flex align-items-start mb-3' key={i}>
                                                                <div className='mnw-icon'>
                                                                    <img src={getImages(getImageType(v.title))} alt='envlope' />
                                                                </div>
                                                                <div className='ps-2'>
                                                                    <div className='pd-sm-title text-blue text-uppercase'>{v.title}</div>
                                                                    <div className='pd-xs-title mt-2'>{v.note}</div>
                                                                </div>
                                                                <div className='ms-auto'>
                                                                    <div className='d-flex'>
                                                                        <div className='pd-xs-title'>{createdAtDate.toLocaleString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true })}</div>
                                                                        <div className='pd-xs-title ms-4'>{createdAtDate.toLocaleString('en-US', { year: "2-digit", month: "2-digit", day: "numeric" })}</div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )
                                                    })}
                                                </div>
                                                <div className="text-start px-0">
                                                    <button className="blue-btn mnw-170 text-center" onClick={() => {createNoteOpenModal(leadData)}}>Create Note</button>
                                                </div>
                                            </div>
                                            <div className='d-md-block d-none'>
                                                <button className='file-icon' type='button'></button>
                                            </div>
                                        </div>
                                        
                                        <div className='d-lg-none'>
                                            <button className='file-icon' type='button' onClick={handleNotesMobileModal}></button>
                                        </div>
                                        {/* } */}
                                    </td>
                                    <td style={{ width: "7%" }} className='text-center pt-3 mob-w-25'>
                                        <div className='mb-2 mob-tb-title d-lg-none'>Timer</div>
                                        <span className='timer-icon'></span>
                                        <div className={`text-center time-time ${stateCls}`}>{finalTimeDifferent} {timeLabel}</div>
                                    </td>
                                    <td style={{ width: "16%" }} className='text-center pt-3'>
                                        <div className='mb-2 mob-tb-title d-lg-none text-start'>Assigned to</div>
                                        <select className='form-control sm-form-control w-100' value={assignee} onChange={(e) => updateAssignee(e.target.value, leadData.Email, leadData.Vin_Number)}>
                                            <option value={leadData.agent_id || "unassigned"}>{leadData.agent_name || "unassigned"}</option>
                                            {agentData.map((agent, i) => {
                                                return (<option value={agent.id} key={i}>{agent.full_name}</option>)
                                            })}
                                        </select>
                                    </td>
                                </tr>}
                            </tbody>
                        </table>
                        {leadData && leadData.notes && Array.isArray(leadData.notes) && leadData.notes.length > 0 && 
                            <div className='d-flex align-items-center mob-desc-block'>
                                <div style={{ width: "5%", padding: "15px 6px" }}></div>
                                <div className='pd-xs-title lh-16 mb-3' style={{ width: "95%" }}>
                                    <span className='text-white'>Last Note: </span>
                                    {isTruncated ? (
                                        <>
                                            {leadData.notes[0].trimmed_note}
                                            {leadData.notes[0].note.length > 300 && <button type="button" className='read-btn' onClick={toggleTruncate}>Read More</button>}
                                        </>
                                    ) : (
                                        <>
                                            {leadData.notes[0].note}
                                            <button type="button" className='read-btn' onClick={toggleTruncate}>Read Less</button>
                                        </>
                                    )}
                                </div>
                            </div>
                        }
                        {openLead === leadData.lead_id ? (
                            <div className="accordion-collapse collapse show">
                                <div className="accordion-body p-0">
                                    <LeadItemAccordion
                                        openPlainTextEmail={openPlainTextEmail}
                                        textLeadModal={textLeadModal}
                                        leadData={leadData}
                                        leadType={leadType}
                                        handleViewDocusign={handleViewDocusign}
                                    />
                                </div>
                            </div>
                        ) : ""}
                    </div>
                </td>
            </tr>
        </>
    )
}

export default LeadItem